module.exports = __webpack_public_path__ + "img/hovered-layer8.c140f929.png";